import React from 'react';
import { Typography } from '@mui/material';
import { Variant } from '@mui/material/createTypography';
import { SimpleTooltipContentProps } from './SimpleTooltipContent.props';

const SimpleTooltipContent = ({ title, defaultText }: SimpleTooltipContentProps) => {
  const titleVariant = { variant: 'h6' as Variant, style: { fontSize: '12px !important' } };
  const bodyVariant = 'body1';
  return (
    <>
      <Typography {...titleVariant}>{title}</Typography>
      <br />
      <Typography variant={bodyVariant}>{defaultText}</Typography>
      <br />
    </>
  );
};

export default SimpleTooltipContent;
